import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Presentation } from "../components/site/Presentation";
import { Solutions } from "../components/site/Solutions";
import { Process } from "../components/site/Process";
import { WhyUs } from "../components/site/WhyUs";
import { Marquee } from "../components/site/Marquee";
import { CtaBand } from "../components/site/CtaBand";
import { LeadForm } from "../components/site/LeadForm";
import { Footer } from "../components/site/Footer";

export default function Landing() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div data-testid="landing-page" className="bg-ink">
            <Header />
            <main>
                <Hero />
                <Presentation />
                <Solutions />
                <Process />
                <WhyUs />
                <Marquee />
                <CtaBand />
                <LeadForm />
            </main>
            <Footer />
        </div>
    );
}
